import { mapGetters } from "vuex";
export default {
  data: () => ({
    isLoad: false,
    isLoading: false,
    dialog: false,
  }),

  methods: {
    modal(){
      this.dialog = !this.dialog;
    },
    closse(){
      this.dialog = false;
    },
  },
  mounted() {
    this.$root.$on('modal.pay', (res) => {
      this.modal();

      this.$nextTick(() => {
        this.$axios.get(`yookassa/order/${res.uuid}/payment`).then(({data}) => {
          //Инициализация виджета. Все параметры обязательные.
          const checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: data.result.token,
            return_url: `${this.getApi}yookassa/order/${res.uuid}/checkout`,
            error_callback: function(error) {
                console.log(error)
            }
          });
  
          //Отображение платежной формы в контейнере
          checkout.render('payment-form')
          this.isLoad = false
        })
      });

    })
  },

  computed: {
    ...mapGetters(['getApi']),
  }
};


// WEBPACK FOOTER //
// ./src/modals/pay/pay.js